// extracted by mini-css-extract-plugin
export default {"ModalBodyTxt":"ConfirmModal_ModalBodyTxt__v675v"};